// Keep the volume readout in the label data passed to player-components.
// This makes it work with both the choir and band mixers without depending on
// a particular cached build of the separate player-components package.
export const withStemVolumePercentage = (stem) => {
  const level = Number(stem && stem.level);
  const percentage = Number.isFinite(level) ? Math.round(level * 100) : 100;

  // The untouched/default level deliberately has no percentage readout.
  if (percentage === 100) return stem;

  return {
    ...stem,
    // Put the percentage first so it remains visible if a long label truncates.
    label: `${percentage}% \u00b7 ${stem.label || ""}`,
  };
};

export const actualStemLevelFromControl = (
  controlLevel,
  currentActualLevel,
  mixerTemplate,
) => {
  const control = Math.min(Math.max(Number(controlLevel) || 0, 0), 1);

  // The studio fader uses its full travel for 0-150%.
  if (mixerTemplate === "band") return control * 1.5;

  // Preserve the choir control's existing tap cycle: 0 -> 100 -> 50 -> 0.
  if (control === 1 && Number(currentActualLevel) === 0) return 1;

  // Its lower half remains 0-50%; its upper half now covers 50-150%.
  if (control <= 0.5) return control;
  return 0.5 + (control - 0.5) * 2;
};

export const controlStemLevelFromActual = (actualLevel, mixerTemplate) => {
  const actual = Math.min(Math.max(Number(actualLevel) || 0, 0), 1.5);
  return mixerTemplate === "band" ? actual / 1.5 : actual;
};

export const makeMixerStems = (
  stems = [],
  userStems = [],
  mixerTemplate = "choir",
) => [...stems, ...userStems].map((stem) => {
  const displayedStem = withStemVolumePercentage(stem);
  return {
    ...displayedStem,
    level: controlStemLevelFromActual(stem.level, mixerTemplate),
  };
});
